import { z } from 'zod';
import { CoreNotifySettingVoiceTextToSpeechVoiceTypeSchema } from '../inputTypeSchemas/CoreNotifySettingVoiceTextToSpeechVoiceTypeSchema'

/////////////////////////////////////////
// CORE NOTIFY SETTING SCHEMA
/////////////////////////////////////////

export const CoreNotifySettingSchema = z.object({
  voiceTextToSpeechVoice: CoreNotifySettingVoiceTextToSpeechVoiceTypeSchema,
  id: z.number().int(),
  cityId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  twilioAccountSid: z.string(),
  suspendedAt: z.coerce.date().nullable(),
  smsTwilioMessagingServiceSid: z.string(),
  smsBrandName: z.string(),
  voiceTwilioPhoneNumberSid: z.string(),
  voiceTwilioPhoneNumber: z.string(),
  voiceBrandName: z.string(),
  billingAccountId: z.number().int(),
})

export type CoreNotifySetting = z.infer<typeof CoreNotifySettingSchema>

export default CoreNotifySettingSchema;
